export const countries = [
    'Aruba',
    'Antigua and Barbuda',
    'United Arab Emirates',
    'Afghanistan',
    'Algeria',
    'Azerbaijan',
    'Albania',
    'Armenia',
    'Andorra',
    'Angola',
    'American Samoa',
    'Argentina',
    'Australia',
    'Ashmore and Cartier Islands',
    'Austria',
    'Anguilla',
    'Åland Islands',
    'Antarctica',
    'Bahrain',
    'Barbados',
    'Botswana',
    'Bermuda',
    'Belgium',
    'Bahamas, The',
    'Bangladesh',
    'Belize',
    'Bosnia and Herzegovina',
    'Bolivia',
    'Myanmar',
    'Benin',
    'Belarus',
    'Solomon Islands',
    'Navassa Island',
    'Brazil',
    'Bassas da India',
    'Bhutan',
    'Bulgaria',
    'Bouvet Island',
    'Brunei',
    'Burundi',
    'Canada',
    'Cambodia',
    'Chad',
    'Sri Lanka',
    'Congo, Republic of the',
    'Congo, Democratic Republic of the',
    'China',
    'Chile',
    'Cayman Islands',
    'Cocos (Keeling) Islands',
    'Cameroon',
    'Comoros',
    'Colombia',
    'Northern Mariana Islands',
    'Coral Sea Islands',
    'Costa Rica',
    'Central African Republic',
    'Cuba',
    'Cape Verde',
    'Cook Islands',
    'Cyprus',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Jarvis Island',
    'Dominican Republic',
    'Dhekelia Sovereign Base Area',
    'Ecuador',
    'Egypt',
    'Ireland',
    'Equatorial Guinea',
    'Estonia',
    'Eritrea',
    'El Salvador',
    'Ethiopia',
    'Europa Island',
    'Czech Republic',
    'French Guiana',
    'Finland',
    'Fiji',
    'Falkland Islands (Islas Malvinas)',
    'Micronesia, Federated States of',
    'Faroe Islands',
    'French Polynesia',
    'Baker Island',
    'France',
    'French Southern and Antarctic Lands',
    'Gambia, The',
    'Gabon',
    'Georgia',
    'Ghana',
    'Gibraltar',
    'Grenada',
    'Guernsey',
    'Greenland',
    'Germany',
    'Glorioso Islands',
    'Guadeloupe',
    'Guam',
    'Greece',
    'Guatemala',
    'Guinea',
    'Guyana',
    'Gaza Strip',
    'Haiti',
    'Hong Kong',
    'Heard Island and McDonald Islands',
    'Honduras',
    'Howland Island',
    'Croatia',
    'Hungary',
    'Iceland',
    'Indonesia',
    'Isle of Man',
    'India',
    'British Indian Ocean Territory',
    'Clipperton Island',
    'Iran',
    'Israel',
    'Italy',
    'Cote d Ivoire',
    'Iraq',
    'Japan',
    'Jersey',
    'Jamaica',
    'Jan Mayen',
    'Jordan',
    'Johnston Atoll',
    'Juan de Nova Island',
    'Kenya',
    'Kyrgyzstan',
    'Korea, North',
    'Kingman Reef',
    'Kiribati',
    'Korea, South',
    'Christmas Island',
    'Kuwait',
    'Kosovo',
    'Kazakhstan',
    'Laos',
    'Lebanon',
    'Latvia',
    'Lithuania',
    'Liberia',
    'Slovakia',
    'Palmyra Atoll',
    'Liechtenstein',
    'Lesotho',
    'Luxembourg',
    'Libyan Arab',
    'Madagascar',
    'Martinique',
    'Macau',
    'Moldova, Republic of',
    'Mayotte',
    'Mongolia',
    'Montserrat',
    'Malawi',
    'Montenegro',
    'The Former Yugoslav Republic of Macedonia',
    'Mali',
    'Monaco',
    'Morocco',
    'Mauritius',
    'Midway Islands',
    'Mauritania',
    'Malta',
    'Oman',
    'Maldives',
    'Mexico',
    'Malaysia',
    'Mozambique',
    'New Caledonia',
    'Niue',
    'Norfolk Island',
    'Niger',
    'Vanuatu',
    'Nigeria',
    'Netherlands',
    'No Mans Land',
    'Norway',
    'Nepal',
    'Nauru',
    'Suriname',
    'Netherlands Antilles',
    'Nicaragua',
    'New Zealand',
    'Paraguay',
    'Pitcairn Islands',
    'Peru',
    'Paracel Islands',
    'Spratly Islands',
    'Pakistan',
    'Poland',
    'Panama',
    'Portugal',
    'Papua New Guinea',
    'Palau',
    'Guinea-Bissau',
    'Qatar',
    'Reunion',
    'Serbia',
    'Marshall Islands',
    'Saint Martin',
    'Romania',
    'Philippines',
    'Puerto Rico',
    'Russia',
    'Rwanda',
    'Saudi Arabia',
    'Saint Pierre and Miquelon',
    'Saint Kitts and Nevis',
    'Seychelles',
    'South Africa',
    'Senegal',
    'Saint Helena',
    'Slovenia',
    'Sierra Leone',
    'San Marino',
    'Singapore',
    'Somalia',
    'Spain',
    'Saint Lucia',
    'Sudan',
    'Svalbard',
    'Sweden',
    'South Georgia and the Islands',
    'Syrian Arab Republic',
    'Switzerland',
    'Trinidad and Tobago',
    'Tromelin Island',
    'Thailand',
    'Tajikistan',
    'Turks and Caicos Islands',
    'Tokelau',
    'Tonga',
    'Togo',
    'Sao Tome and Principe',
    'Tunisia',
    'East Timor',
    'Turkey',
    'Tuvalu',
    'Taiwan',
    'Turkmenistan',
    'Tanzania, United Republic of',
    'Uganda',
    'United Kingdom',
    'Ukraine',
    'United States',
    'Burkina Faso',
    'Uruguay',
    'Uzbekistan',
    'Saint Vincent and the Grenadines',
    'Venezuela',
    'British Virgin Islands',
    'Vietnam',
    'Virgin Islands (US)',
    'Holy See (Vatican City)',
    'Namibia',
    'West Bank',
    'Wallis and Futuna',
    'Western Sahara',
    'Wake Island',
    'Samoa',
    'Eswatini',
    'Serbia and Montenegro',
    'Yemen',
    'Zambia',
];

export const citiesOfCountries = {
    Australia: [
        'Sydney',
    ],
    'New Zealand': [
        'Auckland',
    ],
    UK: [
        'London',
        'Oxford',
    ],
    France: [
        'Paris',
        'Nice',
        'Chatou',
    ],
    Spain: [
        'Barcelona',
    ],

    Germany: [
        'Düsseldorf',
        'Frankfurt',
        'Hannover',
        'Hamburg',
        'Braunschweig',
    ],
    Denmark: [
        'Aarhus',
        'Copenhagen',
    ],

    Sweden: [
        'Stockholm',
        'Gothenburg',
    ],
    Switzerland: [
        'Geneva',
    ],
    Canada: [
        'Montréal',
        'Toronto',
        'Vancouver',
    ],
    'United States': [
        'Phoenix',
        'Berkeley',
        'Hillsborough',
        'Oakland',
        'Sacramento',
        'Oakland',
        'San Francisco',
        'Walnut Creek',
        'Los Angeles',
        'Orange County',
        'San Diego',
        'Denver',
        'Lewes',
        'Atlanta',
        'Sandy Springs',
        'Arlington Heights',
        'Chicago',
        'Waukegan',
        'Dayton',
        'Columbus',
        'Springboro',
        'Silver Springs',
        'Detroit',
        'St. Louis',
        'Greater Saint Paul',
        'Albuquerque',
        'Greenbrook',
        'New York City (all five boroughs)',
        'Dallas',
        'Houston',
        'Salt Lake City',
        'Reston',
    ],
};
